import React from "react";
import { Helmet } from "react-helmet";

import { linkResolver } from "../../utils/prismic-linkResolver";

const MetaSite = ({
  title,
  description,
  image,
  url,
  siteUrl,
  lang,
  altLangs,
  googleAnalytics
}) => {
  const alternates =
    altLangs &&
    altLangs.map((altlang) => {
      return (
        <link
          rel="alternate"
          href={new URL(linkResolver(altlang), siteUrl).href}
          hrefLang={altlang.lang}
          key={altlang.lang}
        />
      );
    });

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {image && <meta property="image" content={image.url} />}
      <link rel="canonical" href={url} />
      <link rel="alternate" href={url} hrefLang={lang} />
      {alternates}
      <link type="text/plain" rel="author" href={`${siteUrl}/humans.txt`} />
      {googleAnalytics ? (
              <script
                async
                src={`https://www.googletagmanager.com/gtag/js?id=${
                  googleAnalytics
                }`}
              />
            ) : null}
            {googleAnalytics ? (
              <script>
                {`window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
        
          gtag('config', '${googleAnalytics}');
        `}
              </script>
          ) : null}
    </Helmet>
  );
};

export default MetaSite;
